import type { EditorPlugin } from '../../types/aha-editor';
import MarkdownPlugin from '../MarkdownPlugin/MarkdownPlugin';
import BlockUtils from './BlockUtils';

interface BlockMarkdownPluginFactoryOptions {
  type: string;
  shortcut: string;
  dependencies?: EditorPlugin[];
}

const BlockMarkdownPluginFactory = ({
  type,
  shortcut,
  dependencies = [],
}: BlockMarkdownPluginFactoryOptions): EditorPlugin => {
  return {
    name: `${type} Block markdown plugin`,
    dependencies: [MarkdownPlugin, ...dependencies],
    markdown: [
      {
        type: 'element',
        regex: new RegExp(`^(${shortcut}\\s)$`),
        triggerCharacter: ' ',
        convert: (editor) => {
          BlockUtils.toggleBlock(editor, type);
          return true;
        },
        revert: (editor, options) => {
          BlockUtils.wrapBlocks(
            editor,
            options.previousBlockType || 'paragraph'
          );
          return true;
        },
        mustBeStartOfBlock: true,
        shiftTabRevert: true,
      },
    ],
  };
};

export default BlockMarkdownPluginFactory;
